import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import history from 'pages/router/history';
import qs from 'qs';

import Group from '@lightspeed/cirrus-group';
import Input from '@lightspeed/cirrus-input';
import { Button } from '@lightspeed/flame/Button';

class SearchBar extends Component {
  constructor(props) {
    super(props);

    const params = qs.parse(window.location.search, { ignoreQueryPrefix: true });

    this.state = {
      searchQuery: (params.filter && params.filter.query) || '',
    };

    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
  }

  handleSearchChange(event) {
    this.setState({ searchQuery: event.target.value });
  }

  handleSearchSubmit(event) {
    event.preventDefault();

    const { searchQuery } = this.state;
    let search = qs.parse(window.location.search, { ignoreQueryPrefix: true });
    let newSearch = {};

    if (searchQuery) {
      newSearch = {
        filter: {
          query: searchQuery,
        },
      };
    }

    if (search.sort) {
      newSearch.sort = search.sort;
    }

    search = qs.stringify(newSearch, {
      encode: false,
    });

    history.replace({ pathname: window.location.pathname, search });
  }

  render() {
    const { searchQuery } = this.state;
    const { placeholder, label, className } = this.props;

    return (
      <form onSubmit={this.handleSearchSubmit} className={className || 'cr-width-6-12'}>
        <Group noSpacing inputBlock>
          <Input
            name="query"
            id="query-input"
            placeholder={placeholder}
            value={searchQuery}
            onChange={this.handleSearchChange}
            data-test="search-bar-query-input"
          />
          <Button type="submit" variant="secondary">
            {label}
          </Button>
        </Group>
      </form>
    );
  }
}

SearchBar.propTypes = {
  placeholder: PropTypes.string,
  label: PropTypes.node,
  className: PropTypes.string,
};

SearchBar.defaultProps = {
  placeholder: 'Search',
  label: 'Search',
  className: null,
};

export default connect()(SearchBar);
